module.exports = __webpack_public_path__ + "img/minerva.53accf2c.jpeg";